export default {
  name: 'will-must-detail',
  async created () {
    let param = {
      'user_id': window.localStorage.getItem('user_id'),
      'will_must_date': this.$route.params.id
    }
    await this.$store.dispatch('GET_WILL_MUST', {data: param, callback: this.set})
  },
  data () {
    return {
      willMustMonth: null,
      willMustYear: null,
      callbackFlag: false
    }
  },
  computed: {
    willMustDate () {
      return this.$store.getters.willMustDate
    },
    will () {
      return this.$store.getters.willDetail
    },
    must () {
      return this.$store.getters.mustDetail
    },
    reflect () {
      return this.$store.getters.reflectDetail
    },
    evaluation () {
      return this.$store.getters.evaluationDetail
    },
    evaluationText () {
      switch (this.evaluation) {
        case 'A':
          return '具体的な行動を実行し、手応えを感じる'
        case 'B':
          return '行動はしたが、満足する手応えを感じる事が出来ていない'
        case 'C':
          return '行動が不足しており、手応えを感じる事が出来ていない'
      }
    }
  },
  methods: {
    goBack: function () {
      this.$router.push({path: '/will_must_list'})
    },
    set: function () {
      let date = new Date(this.$route.params.id)
      this.willMustMonth = date.getMonth() + 1
      this.willMustYear = date.getFullYear()
      this.callbackFlag = true
    },
    content: function (word) {
      return word ? word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r?\n/g, '<br>') : ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/will-must-detail.js